"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var styles_1 = require("../../styles");
var HTMLEditor_1 = __importDefault(require("../editor/HTMLEditor"));
var SortableGalleryInput_1 = __importDefault(require("../SortableGalleryInput"));
var ObjectForm_1 = __importStar(require("../ObjectForm"));
var hooks_1 = require("../../hooks");
var hooks_2 = require("../../modules/categories/hooks");
var SectionTextRaw_1 = __importDefault(require("../sections/SectionTextRaw"));
var hooks_3 = require("../../modules/stations/hooks");
var hooks_4 = require("../../modules/sections/hooks");
var styles = {
    contentItemCard: {
        marginBottom: "12px",
        position: "relative",
    },
    contentItemHeaderExtra: {
        position: "absolute",
        height: 22,
        top: "8px",
        right: "12px",
        zIndex: 1,
        display: "flex",
        gap: 8,
        alignItems: "center",
    },
    contentItemHeaderExtraNumber: { color: "#CCC" },
    contentContainer: { marginBottom: 0 },
    removeContentItem: { color: "#f5222d" },
    quizOptionsFieldSpace: { display: "flex", marginBottom: 8 },
    quizOptionLabel: { width: 400 },
    quizAnswerSelect: { width: 150 },
};
// Maximum number of days each month can have.
var MONTH_DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var zoneOptions = [];
for (var i = 1; i < 61; i++) {
    var numeral = String(i).padStart(2, "0");
    for (var li = 67; li < 91; li++) {
        var str = "".concat(numeral).concat(String.fromCharCode(li));
        zoneOptions.push({ value: str, label: str });
    }
}
zoneOptions.push({ value: "A", label: "A" }, { value: "B", label: "B" });
var contentTypes = [
    { value: "html", label: "Rich Text" },
    { value: "gallery", label: "Gallery" },
    { value: "quiz", label: "Quiz" },
];
var quizTypes = [
    { value: "match_values", label: "Match values" },
    { value: "select_all_that_apply", label: "Select all that apply" },
    { value: "choose_one", label: "Choose the correct option" },
];
var quizAnswerOptions = [
    { value: true, label: "Correct" },
    { value: false, label: "Incorrect" },
];
var fieldPaths = {
    visible_from: ["visible", "from"],
    visible_to: ["visible", "to"],
    coordinates_utm_crs: ["coordinates_utm", "crs"],
    coordinates_utm_zone: ["coordinates_utm", "zone"],
    coordinates_utm_east: ["coordinates_utm", "east"],
    coordinates_utm_north: ["coordinates_utm", "north"],
    revision_message: ["revision", "message"],
};
var WYSIWYG_BLANKS = [
    "",
    "&nbsp;",
    "<p></p>",
    "<p><br></p>",
    "<p>&nbsp;</p>",
];
var normalizeHTMLContent = function (content) {
    if (!content)
        return "";
    content = content.trim();
    if (WYSIWYG_BLANKS.includes(content)) {
        // Annoying fake-empty content
        return "";
    }
    // These "narrow non-breaking spaces" were popping up a lot
    // with pastes from Word and created unintentionally strange
    // wrapping behaviour. Replace them with normal spaces.
    content = content.replace("\u202f", " ");
    return content;
};
var contentItemField = function (i) { return function (k) { return "contents_".concat(i, "_").concat(k); }; };
var normalizeContents = function (c) { return c ? (__assign(__assign(__assign(__assign(__assign({}, c), { title: c.title || "" }), (c.content_type === "html" ? {
    content_before_fold: normalizeHTMLContent(c.content_before_fold),
    content_after_fold: normalizeHTMLContent(c.content_after_fold),
} : {})), (c.content_type === "gallery" ? {
    description: normalizeHTMLContent(c.description),
    items: c.items || [],
} : {})), (c.content_type === "quiz" ? {
    question: normalizeHTMLContent(c.question),
    answer: normalizeHTMLContent(c.answer),
    options: (c.options || []).map(function (o) { return (__assign(__assign({}, o), (["select_all_that_apply", "choose_one"].includes(c.quiz_type) ? {
        // "cast" these answers to booleans
        answer: o.answer, // fromAPI ? (o.answer ? "true" : "false") : (o.answer === "true"),
    } : {}))); }),
} : {}))) : ({
    content_type: null,
    title: "",
}); };
var monthDayValidator = function (r, v) {
    if (!v)
        return Promise.resolve();
    if (!/^\d{2}-\d{2}$/.test(v)) {
        return Promise.reject(r.message);
    }
    var _a = v.split("-").map(function (e) { return parseInt(e, 10); }), month = _a[0], day = _a[1];
    if (month < 1 || month > 12 || day < 1 || day > MONTH_DAYS[month - 1]) {
        return Promise.reject(r.message);
    }
    return Promise.resolve();
};
var filterOption = function (input, option) {
    return option.label.toLowerCase().includes(input.toLowerCase());
};
var StationForm = react_1.default.memo(function (props) {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var sections = (0, hooks_4.useSections)().items;
    var numStations = (0, hooks_3.useStations)().items.length;
    var categories = (0, hooks_2.useCategories)().items;
    var assets = (0, hooks_1.useAppSelector)(function (state) { return state.assets.items; });
    var headerImageOptions = (0, react_1.useMemo)(function () { return assets
        .filter(function (a) { return a.asset_type === "image"; })
        .map(function (a) { return ({ value: a.id, label: a.file_name }); }); }, [assets]);
    var sectionOptions = (0, react_1.useMemo)(function () { return sections.map(function (_a) {
        var id = _a.id, title = _a.title, color = _a.color;
        return ({ value: id, label: react_1.default.createElement(SectionTextRaw_1.default, { title: title, color: color }) });
    }); }, [sections]);
    var categoryOptions = (0, react_1.useMemo)(function () { return categories.map(function (_a) {
        var value = _a.id;
        return ({ value: value });
    }); }, [categories]);
    var transformInitialValues = (0, react_1.useCallback)(function (v) {
        var _a, _b, _c, _d, _e, _f;
        return (__assign(__assign({ rank: numStations, coordinates_utm: __assign({ crs: "NAD83", zone: "18T" }, ((_a = v.coordinates_utm) !== null && _a !== void 0 ? _a : {})) }, v), { enabled: !!v.enabled, revision: {
                working_copy: (_c = (_b = v.revision) === null || _b === void 0 ? void 0 : _b.number) !== null && _c !== void 0 ? _c : null,
                message: "", // Clear revision message for possible filling out & re-submission
            }, visible: {
                from: ((_d = v.visible) === null || _d === void 0 ? void 0 : _d.from) || null,
                to: ((_e = v.visible) === null || _e === void 0 ? void 0 : _e.to) || null,
            }, contents: ((_f = v.contents) !== null && _f !== void 0 ? _f : []).map(normalizeContents) }));
    }, [numStations]);
    var contentsRefs = (0, react_1.useRef)({});
    var getContentKey = (0, react_1.useCallback)(function (k, i) {
        var _a;
        var _b, _c, _d;
        return (_a = {},
            _a[k] = normalizeHTMLContent((_d = (_c = (_b = contentsRefs === null || contentsRefs === void 0 ? void 0 : contentsRefs.current[contentItemField(i)(k)]) === null || _b === void 0 ? void 0 : _b.getEditor()) === null || _c === void 0 ? void 0 : _c.root) === null || _d === void 0 ? void 0 : _d.innerHTML),
            _a);
    }, [contentsRefs]);
    var transformFinalValues = (0, react_1.useCallback)(function (v) {
        var _a, _b, _c, _d, _e;
        return (__assign(__assign({}, v), { title: (_a = v.title) !== null && _a !== void 0 ? _a : "", long_title: (_b = v.long_title) !== null && _b !== void 0 ? _b : "", subtitle: (_c = v.subtitle) !== null && _c !== void 0 ? _c : "", 
            // Properly type everything
            visible: {
                from: v.visible.from || null,
                to: v.visible.to || null,
            }, header_image: (_d = v.header_image) !== null && _d !== void 0 ? _d : null, coordinates_utm: __assign(__assign({}, v.coordinates_utm), { east: v.coordinates_utm.east ? parseInt(v.coordinates_utm.east, 10) : undefined, north: v.coordinates_utm.north ? parseInt(v.coordinates_utm.north, 10) : undefined }), contents: ((_e = v.contents.map(normalizeContents)) !== null && _e !== void 0 ? _e : []).map(function (c, ci) {
                switch (c.content_type) {
                    case "html":
                        return __assign(__assign(__assign({}, c), getContentKey("content_before_fold", ci)), getContentKey("content_after_fold", ci));
                    case "gallery":
                        return __assign(__assign({}, c), getContentKey("description", ci));
                    case "quiz":
                        return __assign(__assign(__assign({}, c), getContentKey("question", ci)), getContentKey("answer", ci));
                }
            }), enabled: !!v.enabled, rank: parseInt(v.rank) }));
    }, [getContentKey]);
    var contentFieldChanged = (0, react_1.useCallback)(function (field, contentField) { return function (prevValues, newValues) {
        var _a, _b;
        var ct1 = (_a = prevValues.contents[field.name]) === null || _a === void 0 ? void 0 : _a[contentField];
        var ct2 = (_b = newValues.contents[field.name]) === null || _b === void 0 ? void 0 : _b[contentField];
        return ct1 !== ct2;
    }; }, []);
    var onView = (0, react_1.useCallback)(function (v) {
        if (!v.id)
            return;
        navigate("/stations/detail/".concat(v.id), { replace: true });
    }, [navigate]);
    var objectForm = (0, ObjectForm_1.useObjectForm)(__assign({ transformInitialValues: transformInitialValues, transformFinalValues: transformFinalValues, onView: onView }, props));
    var form = objectForm.form, transformedInitialValues = objectForm.transformedInitialValues, processLocalChanges = objectForm.processLocalChanges;
    return react_1.default.createElement(ObjectForm_1.default, __assign({ objectForm: objectForm }, props),
        react_1.default.createElement(antd_1.Row, { gutter: 12 },
            react_1.default.createElement(antd_1.Col, { span: 8 },
                react_1.default.createElement(antd_1.Form.Item, { name: "title", label: "Title", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Input, null))),
            react_1.default.createElement(antd_1.Col, { span: 16 },
                react_1.default.createElement(antd_1.Form.Item, { name: "long_title", label: "Long Title", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Input, null)))),
        react_1.default.createElement(antd_1.Row, { gutter: 12 },
            react_1.default.createElement(antd_1.Col, { flex: 1 },
                react_1.default.createElement(antd_1.Form.Item, { name: "subtitle", label: "Subtitle", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Input, null))),
            react_1.default.createElement(antd_1.Col, { flex: "140px" },
                react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.visible_from, label: "Visible From", rules: [
                        { validator: monthDayValidator, message: "Format is MM-DD" },
                        function (_a) {
                            var getFieldValue = _a.getFieldValue;
                            return ({
                                validator: function (_, v) {
                                    return (!v && getFieldValue(fieldPaths.visible_to))
                                        ? Promise.reject(new Error("visible.to requires that visible.from is filled as well"))
                                        : Promise.resolve();
                                },
                            });
                        },
                    ] },
                    react_1.default.createElement(antd_1.Input, { placeholder: "MM-DD" }))),
            react_1.default.createElement(antd_1.Col, { flex: "140px" },
                react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.visible_to, label: "Visible To", rules: [
                        { validator: monthDayValidator, message: "Format is MM-DD" },
                        function (_a) {
                            var getFieldValue = _a.getFieldValue;
                            return ({
                                validator: function (_, v) {
                                    return (!v && getFieldValue(fieldPaths.visible_from))
                                        ? Promise.reject(new Error("visible.from requires that visible.to is filled as well"))
                                        : Promise.resolve();
                                },
                            });
                        },
                    ] },
                    react_1.default.createElement(antd_1.Input, { placeholder: "MM-DD" }))),
            react_1.default.createElement(antd_1.Col, { flex: "80px" },
                react_1.default.createElement(antd_1.Form.Item, { name: "enabled", label: "Enabled", valuePropName: "checked" },
                    react_1.default.createElement(antd_1.Switch, null))),
            react_1.default.createElement(antd_1.Col, { span: 4 },
                react_1.default.createElement(antd_1.Form.Item, { name: "rank", label: "Rank" },
                    react_1.default.createElement(antd_1.Input, { type: "number", min: 0 })))),
        react_1.default.createElement(antd_1.Row, { gutter: 12 },
            react_1.default.createElement(antd_1.Col, { span: 6 },
                react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.coordinates_utm_crs, label: "CRS", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Select, null,
                        react_1.default.createElement(antd_1.Select.Option, { value: "NAD83" }, "NAD83")))),
            react_1.default.createElement(antd_1.Col, { span: 6 },
                react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.coordinates_utm_zone, label: "UTM Zone", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Select, { showSearch: true, filterOption: filterOption, options: zoneOptions }))),
            react_1.default.createElement(antd_1.Col, { span: 6 },
                react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.coordinates_utm_east, label: "Easting", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Input, { type: "number", addonAfter: "E" }))),
            react_1.default.createElement(antd_1.Col, { span: 6 },
                react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.coordinates_utm_north, label: "Northing", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Input, { type: "number", addonAfter: "N" })))),
        react_1.default.createElement(antd_1.Row, { gutter: 12 },
            react_1.default.createElement(antd_1.Col, { span: 8 },
                react_1.default.createElement(antd_1.Form.Item, { name: "header_image", label: "Header Image" },
                    react_1.default.createElement(antd_1.Select, { placeholder: "Select header image for this station", allowClear: true, showSearch: true, options: headerImageOptions }))),
            react_1.default.createElement(antd_1.Col, { span: 8 },
                react_1.default.createElement(antd_1.Form.Item, { name: "section", label: "Section", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Select, { placeholder: "Select app section for this station", options: sectionOptions }))),
            react_1.default.createElement(antd_1.Col, { span: 8 },
                react_1.default.createElement(antd_1.Form.Item, { name: "category", label: "Category", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Select, { placeholder: "Select category for this station", options: categoryOptions })))),
        react_1.default.createElement(antd_1.Form.List, { name: "contents" }, function (fields, _a, _b) {
            var add = _a.add, move = _a.move, remove = _a.remove;
            var errors = _b.errors;
            return react_1.default.createElement(react_1.default.Fragment, null,
                errors,
                fields.map(function (field, idx) {
                    var fi = contentItemField(field.name);
                    return react_1.default.createElement(antd_1.Card, { key: field.key, size: "small", title: "Content Item", style: styles.contentItemCard },
                        react_1.default.createElement("div", { style: styles.contentItemHeaderExtra },
                            react_1.default.createElement("span", { style: styles.contentItemHeaderExtraNumber },
                                "#",
                                idx + 1),
                            fields.length > 1 && react_1.default.createElement(react_1.default.Fragment, null,
                                idx > 0 && (react_1.default.createElement(antd_1.Tooltip, { title: "Move content item up" },
                                    react_1.default.createElement(icons_1.UpOutlined, { onClick: function () { return move(idx, idx - 1); } }))),
                                idx < fields.length - 1 && (react_1.default.createElement(antd_1.Tooltip, { title: "Move content item down" },
                                    react_1.default.createElement(icons_1.DownOutlined, { onClick: function () { return move(idx, idx + 1); } }))),
                                react_1.default.createElement(antd_1.Divider, { type: "vertical" })),
                            react_1.default.createElement(antd_1.Tooltip, { title: "Remove content item" },
                                react_1.default.createElement(icons_1.CloseCircleOutlined, { style: styles.removeContentItem, onClick: function () { return remove(field.name); } }))),
                        react_1.default.createElement(antd_1.Form.Item, { noStyle: true },
                            react_1.default.createElement(antd_1.Row, { gutter: 12 },
                                react_1.default.createElement(antd_1.Col, { span: 8 },
                                    react_1.default.createElement(antd_1.Form.Item, __assign({}, field, { validateTrigger: ["onChange", "onBlur"], key: "content_type", label: "Content Type", name: [field.name, "content_type"], rules: ObjectForm_1.RULES_REQUIRED_BASIC }),
                                        react_1.default.createElement(antd_1.Select, { placeholder: "Content Type", options: contentTypes }))),
                                react_1.default.createElement(antd_1.Col, { span: 16 },
                                    react_1.default.createElement(antd_1.Form.Item, __assign({}, field, { key: "title", label: "Title", name: [field.name, "title"] }),
                                        react_1.default.createElement(antd_1.Input, { placeholder: "Title" })))),
                            react_1.default.createElement(antd_1.Form.Item, { shouldUpdate: contentFieldChanged(field, "content_type"), style: styles.contentContainer }, function (f) {
                                var _a, _b;
                                var initialContents = transformedInitialValues.contents[field.name];
                                var updateContentRef = function (fk) { return function (el) {
                                    var _a;
                                    contentsRefs.current = __assign(__assign({}, contentsRefs.current), (_a = {}, _a[fi(fk)] = el, _a));
                                }; };
                                switch (f.getFieldValue(["contents", field.name, "content_type"])) {
                                    case "html":
                                        return react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("p", { style: styles_1.helpText }, "Use this content type for article-style content, for example mixed text and multimedia."),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "content_before_fold", label: "Content Before Fold" },
                                                react_1.default.createElement(HTMLEditor_1.default, { initialValue: (_a = initialContents === null || initialContents === void 0 ? void 0 : initialContents.content_before_fold) !== null && _a !== void 0 ? _a : "", innerRef: updateContentRef("content_before_fold"), helpText: "Initial / above-the-fold / main content to show." })),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "content_after_fold", label: "Content After Fold", style: { marginBottom: 0 } },
                                                react_1.default.createElement(HTMLEditor_1.default, { initialValue: (_b = initialContents === null || initialContents === void 0 ? void 0 : initialContents.content_after_fold) !== null && _b !== void 0 ? _b : "", innerRef: updateContentRef("content_after_fold"), helpText: "Content to be hidden behind a 'Read More' button. If this is left blank, no " +
                                                        "'Read More' button will be found." })));
                                    case "gallery":
                                        return react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("p", { style: styles_1.helpText }, "Use this content type for a gallery of images. Captions can be provided, or left out."),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "description", label: "Description", name: [field.name, "description"] },
                                                react_1.default.createElement(HTMLEditor_1.default, { initialValue: initialContents === null || initialContents === void 0 ? void 0 : initialContents.description, innerRef: updateContentRef("description"), helpText: "Descriptive text for the entire gallery. In most cases, images DO NOT go here!" })),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "items", label: "Images", name: [field.name, "items"] },
                                                react_1.default.createElement(SortableGalleryInput_1.default, null)));
                                    case "quiz":
                                        return react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("p", { style: styles_1.helpText }, "Use this content type for creating an interactive quiz. Currently, three types of quizzes are available: A 'match values' quiz, for matching values to a provided picture or set of hints; a 'select all that apply' quiz; and a 'choose the correct answer' quiz."),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "quiz_type", label: "Quiz Type", name: [field.name, "quiz_type"] },
                                                react_1.default.createElement(antd_1.Select, { options: quizTypes, onChange: function () {
                                                        form.setFieldsValue({
                                                            contents: form.getFieldsValue().contents.map(function (c, i) {
                                                                return i === field.name ? __assign(__assign({}, c), { options: [] }) : c;
                                                            }),
                                                        });
                                                    } })),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "question", label: "Question" },
                                                react_1.default.createElement(HTMLEditor_1.default, { initialValue: initialContents === null || initialContents === void 0 ? void 0 : initialContents.question, innerRef: updateContentRef("question") })),
                                            react_1.default.createElement(antd_1.Form.Item, { key: "answer", label: "Answer" },
                                                react_1.default.createElement(HTMLEditor_1.default, { initialValue: initialContents === null || initialContents === void 0 ? void 0 : initialContents.answer, innerRef: updateContentRef("answer") })),
                                            react_1.default.createElement(antd_1.Form.Item, { label: "Options" },
                                                react_1.default.createElement(antd_1.Form.List, { name: [field.name, "options"] }, function (optionFields, _a) {
                                                    var addOpt = _a.add, removeOpt = _a.remove;
                                                    return (react_1.default.createElement(react_1.default.Fragment, null,
                                                        optionFields.map(function (optionField) { return (react_1.default.createElement(antd_1.Space, { key: optionField.key, style: styles.quizOptionsFieldSpace, align: "baseline" },
                                                            react_1.default.createElement(antd_1.Form.Item, __assign({}, optionField, { label: "Label", name: [optionField.name, "label"], rules: ObjectForm_1.RULES_REQUIRED_BASIC }),
                                                                react_1.default.createElement(antd_1.Input, { placeholder: "Label", style: styles.quizOptionLabel })),
                                                            react_1.default.createElement(antd_1.Form.Item, { label: "Answer", shouldUpdate: contentFieldChanged(field, "quiz_type") }, function (f) {
                                                                var answerName = [optionField.name, "answer"];
                                                                switch (f.getFieldValue(["contents", field.name, "quiz_type"])) {
                                                                    case "match_values":
                                                                        return react_1.default.createElement(antd_1.Form.Item, { name: answerName, rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                                                                            react_1.default.createElement(antd_1.Input, { placeholder: "Answer" }));
                                                                    default:
                                                                        // select_all_that_apply
                                                                        // choose_one
                                                                        return react_1.default.createElement(antd_1.Form.Item, { name: answerName, rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                                                                            react_1.default.createElement(antd_1.Select, { style: styles.quizAnswerSelect, options: quizAnswerOptions }));
                                                                }
                                                            }),
                                                            react_1.default.createElement(icons_1.MinusCircleOutlined, { onClick: function () { return removeOpt(optionField.name); } }))); }),
                                                        react_1.default.createElement(antd_1.Form.Item, null,
                                                            react_1.default.createElement(antd_1.Button, { type: "dashed", onClick: function () { return addOpt(); }, block: true, icon: react_1.default.createElement(icons_1.PlusOutlined, null) }, "Add Option"))));
                                                })));
                                }
                            })));
                }),
                react_1.default.createElement(antd_1.Form.Item, null,
                    react_1.default.createElement(antd_1.Button, { onClick: function () {
                            add();
                            // noinspection JSValidateTypes
                            processLocalChanges();
                        }, icon: react_1.default.createElement(icons_1.PlusOutlined, null) }, "Add Content Item")));
        }),
        react_1.default.createElement(antd_1.Divider, null),
        react_1.default.createElement(antd_1.Form.Item, { name: fieldPaths.revision_message, label: "Revision Message" },
            react_1.default.createElement(antd_1.Input, null)));
});
exports.default = StationForm;
